import { Tabs, Tab, Box } from '@mui/material'
import { Paper } from '@mui/material'
import { EnhancedTabsProps, TabConfig } from './tabs.types'
import EnhancedTabPanel from './EnhancedTabPanel'
import { a11yProps } from './utils'
import { SyntheticEvent } from 'react'
import { useActiveTab } from '@common/hooks/useActiveTab'
import { useTabOptionalComponent } from '@common/hooks/useTabOptionalComponent'
import { Search } from '../Search'
import { SPACING } from '@common/theme/spacing'
import React from 'react'

export default function EnhancedTabs<T extends string | number | symbol>({
  tabs,
  searchEnabled,
}: EnhancedTabsProps<T>) {
  const { currentActiveTab, setCurrentActiveTab } = useActiveTab()
  const { optionalComponent, isComponentVisible, setIsComponentUsed } = useTabOptionalComponent()

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setCurrentActiveTab(newValue)
  }
  const tab_values: TabConfig[] = Object.values(tabs)

  return (
    <Paper
      sx={{
        padding: SPACING.paperInnerPadding,
        borderRadius: SPACING.borderRadiusXl,
      }}
    >
      <Box
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        {tab_values.length > 1 ? (
          <Box
            sx={{
              bgcolor: 'secondary.light',
              borderRadius: 1.5,
              padding: 0.5,
              typography: 'subtitle1',
            }}
          >
            <Tabs
              sx={{
                alignItems: 'center',
                height: 36,
                minHeight: 'unset',
              }}
              TabIndicatorProps={{
                style: { display: 'none' },
              }}
              value={currentActiveTab}
              onChange={handleChange}
              aria-label="enhanced tabs"
            >
              {tab_values.map((tab, index) => (
                <Tab
                  key={index}
                  sx={{
                    borderRadius: 1,
                    bgcolor: currentActiveTab === index ? 'background.default' : 'secondary.light',
                    color: 'text.primary',
                    typography: 'subtitle1',
                  }}
                  label={tab.label}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
        ) : (
          <Box
            sx={{
              borderRadius: 1.5,
              padding: 0.5,
              typography: 'subtitle1',
            }}
          />
        )}
        {searchEnabled && <Search />}
        {isComponentVisible && <Box onClick={() => setIsComponentUsed(true)}>{optionalComponent}</Box>}
      </Box>

      {tab_values.map((tab, index) => (
        <EnhancedTabPanel key={index} value={currentActiveTab} index={index}>
          {React.isValidElement(tab.content)
            ? React.cloneElement(
                tab.content as React.ReactElement<{ isRawDataEnabled?: boolean; isBluerockEnabled?: boolean }>,
                {
                  isRawDataEnabled: tab.isRawDataEnabled,
                  isBluerockEnabled: tab.isBluerockEnabled,
                },
              )
            : tab.content}
        </EnhancedTabPanel>
      ))}
    </Paper>
  )
}
